<template>
  <div :class="['item-content', { active: active }]">
    <div class="left-content">
      <img :src="item.icon" alt="" role="presentation" class="item-logo" />
      <div class="item-text">
        {{ $t(item.text) }}
        <span v-if="opensInNewTab" class="item-new-tab-label">
          {{ $t('navigation.OPENS_IN_NEW_TAB') }}
        </span>
      </div>
    </div>

    <NewTabIcon
      v-if="opensInNewTab"
      class="item-new-tab-icon"
      aria-hidden="true"
      data-cy="sidebar-item-new-tab-icon"
    />
    <ChevronIcon
      v-if="hasSubItems"
      class="item-chevron-icon"
      direction="down"
    />
  </div>
</template>

<script>
import ChevronIcon from '@/components/icon_components/ChevronIcon.vue'
import NewTabIcon from '@/components/icon_components/NewTabIcon.vue'
import { LINK_TARGET_NEW_TAB } from '@/helpers/constants.js'

export default {
  components: {
    ChevronIcon,
    NewTabIcon,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    active: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    hasSubItems() {
      return this.item.children.length > 0
    },
    opensInNewTab() {
      return this.item.target === LINK_TARGET_NEW_TAB
    },
  },
}
</script>

<style lang="scss" scoped>
.item-content {
  align-items: center;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  padding: $spacing-4xs $spacing-3xs;

  .left-content {
    display: flex;
    align-items: center;
    gap: $spacing-4xs;

    .item-logo {
      width: $spacing-s;
      height: $spacing-s;
      object-fit: contain;
    }
    .item-text {
      color: $color-text-light;
      font-weight: 700;
      font-size: $font-size-s;
    }
  }

  @media screen and (min-width: $large-desktop-width-max) {
    .left-content {
      gap: $spacing-3xs;

      .item-logo {
        width: 28px;
        height: 28px;
      }
      .item-text {
        font-size: $font-size-m;
      }
    }
  }
  &.active .left-content .item-text {
    color: $color-text;
    font-weight: 900;
  }

  .item-new-tab-label {
    @include visuallyHidden;
  }

  .item-new-tab-icon,
  .item-chevron-icon {
    width: $spacing-3xs;
    height: $spacing-3xs;
    color: $color-text-light;
  }
}
</style>
